import { useRef } from 'react';
import getServiceDataKey from '../../utils/getServiceDataKey';
import useInteractiveShopModals from '../../model/hooks/useInteractiveShopModals';
import { useService } from '../../../../../redux/reducer/service';
import Item from '../Item/Item';
// import useOnboarding from '../../model/hooks/useOnboarding';
import { useOnboardingContext } from '../../../../../providers/onboarding-provider';

export default function Items({ items, highlightData: [highlightedItem] }) {
  const { serviceData } = useService();
  const openModal = useInteractiveShopModals(arguments[0]);

  const itemsRef = useRef({});

  const { shouldShowOnboardingStep } = useOnboardingContext();

  // useOnboarding({...arguments[0], itemsRef});

  return items.map((itemData) => {
    const { img, shadow, action, className, isFly = true } = itemData;
    const buttonLogic = getButtonLogic(itemData);
    const props = {
      action,
      buttonLogic,
      isHidden: action === highlightedItem,
      className,
      img,
      shadow,
      isFly,
      ref: itemsRef,
    };
    return <Item key={action} {...props} />;
  });

  function getButtonLogic(itemData) {
    const { action, button: buttonLogic } = itemData;
    const { modalsData = {} } = serviceData ?? {};
    return !modalsData[getServiceDataKey(action)] || shouldShowOnboardingStep(action)
      ? { onClick: (e) => openModal(e, itemData) }
      : buttonLogic;
  }
}
